import NavMokaLogo from './NavMokaLogo'
import NavLoggedIn from './NavLoggedIn'
import NavNotLoggedIn from './NavNotLoggedIn'
import NavOutlet from 'components/NavOutlet'
import styles from './style.css'
import {hideTransactionDetailModal, setTransactionDetail} from 'actions/reports/transactions'
import {setReceiptInvoices, hideReceiptInvoice} from 'actions/reports/invoices'
class Nav extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    if (this.props.loggedIn !== nextProps.loggedIn) {
      return true
    }
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true
    }

    let { user } = this.props
    let nextUser = nextProps.user
    if (user || nextUser) {
      if (user.first_name !== nextUser.first_name) {
        return true
      }
      if (user.last_name !== nextUser.last_name) {
        return true
      }
      if (user.email !== nextUser.last_name) {
        return true
      }
    }
    return false
  }

  render () {
    return (
      <nav className={'navbar mk-navbar ' + styles['navbar-moka']} role='navigation'>
        <div className='container'>
          <div className={`col-xs-3 col-md-1 col-image ${styles['logo-wrapper']}`}>
            <NavMokaLogo link={this.props.loggedIn ? this._mokaLogoLink() : '/login'} />
          </div>
          <div className='col-xs-6 nav-outlet visible-xs visible-sm '>
            {this.props.loggedIn && this.props.location.pathname !== '/settings/billing' && <NavOutlet {...this.props} onChangeOutlet={this._onChangeOutlet} />}
          </div>
          <div className='col-xs-3 visible-sm visible-xs'>
            <button
              className='navbar-toggle navbar-toggle-always'
              data-toggle='collapse'
              data-target={this.props.loggedIn ? '#NavLoggedIn' : '#NavNotLoggedIn'}
              aria-controls='NavNotLoggedIn'
              aria-expanded='false'
              type='button'
              onClick={() => { this._onClickHamburgerButton() }}>
              <span className='sr-only'>Menu</span>
              <span className='icon-bar' />
              <span className='icon-bar' />
              <span className='icon-bar' />
            </button>
          </div>
          <div className={`col-xs-12 col-md-11 col-menu ${styles['navbar-wrapper']}`}>
            { this.props.location.pathname === '/confirm-employee-invitation' || this.props.location.pathname === '/success-confirm-employee-invitation' || this.props.location.pathname.startsWith('/verify-email-alert-recipient')
              ? <NavNotLoggedIn {...this.props} />
              : this.props.loggedIn
                ? <NavLoggedIn {...this.props} />
                : <NavNotLoggedIn {...this.props} />
            }
          </div>
        </div>
      </nav>
    )
  }

  _onChangeOutlet (outletIds, pathname) {
  }

  _onClickHamburgerButton = () => {
    this.props.dispatch(setTransactionDetail(null))
    this.props.dispatch(hideTransactionDetailModal())
    this.props.dispatch(setReceiptInvoices(null))
    this.props.dispatch(hideReceiptInvoice(true))
  }

  _mokaLogoLink = () => {
    const {user} = this.props
    if (user) {
      if (user.is_owner || user.is_manager) {
        return '/dashboard'
      } else {
        return '/settings/accounts'
      }
    } else {
      return '/login'
    }
  }
}

Nav.propTypes = {
  loggedIn: React.PropTypes.bool,
  currentlySending: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
}

export default Nav



// WEBPACK FOOTER //
// ./app/components/Nav/Nav.js